import { render, staticRenderFns } from "./feeConfig.vue?vue&type=template&id=3c5ad920&scoped=true&"
import script from "./feeConfig.vue?vue&type=script&lang=js&"
export * from "./feeConfig.vue?vue&type=script&lang=js&"
import style0 from "./feeConfig.vue?vue&type=style&index=0&id=3c5ad920&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5ad920",
  null
  
)

export default component.exports